/**
 * @generated SignedSource<<f4f4e22c444f53df76a690adf4f8005d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGrid_similarItems$data = ReadonlyArray<{
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly ecommerceTrackingParams: any | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespRelatedItem_item">;
  readonly " $fragmentType": "PdpRespSimilarItemsGrid_similarItems";
}>;
export type PdpRespSimilarItemsGrid_similarItems$key = ReadonlyArray<{
  readonly " $data"?: PdpRespSimilarItemsGrid_similarItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_similarItems">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpRespSimilarItemsGrid_similarItems",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ecommerceTrackingParams",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "SharedRespRelatedItem_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "a2a5b9cad7ce964ae720ca300c9e38a9";

export default node;
